// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReactResponsive$PrezzeeRibbon from "./ReactResponsive.bs.js";

function MediaQuery(props) {
  var matches = ReactResponsive$PrezzeeRibbon.useMediaQuery(props.query);
  if (matches) {
    return props.children;
  } else {
    return null;
  }
}

var make = MediaQuery;

export {
  make ,
}
/* ReactResponsive-PrezzeeRibbon Not a pure module */
